/** Klucze w tabeli app_settings — muszą być zgodne z mobile/src/constants/legalDocuments.js */
export const LEGAL_SETTING_KEYS = {
  regulamin: 'legalRegulaminBlocks',
  privacy: 'legalPrivacyPolicyHtml',
  deklaracja: 'legalDeklaracjaDostepnosciBlocks',
  informacja: 'legalInformacjaPrzetwarzanieBlocks',
};

export const LEGAL_DOCUMENTS = [
  {
    id: 'regulamin',
    label: 'Regulamin aplikacji',
    description:
      'Wyświetlany w „O aplikacji” oraz przy pierwszym uruchomieniu aplikacji (akceptacja regulaminu).',
    settingKey: LEGAL_SETTING_KEYS.regulamin,
  },
  {
    id: 'privacy',
    label: 'Polityka prywatności',
    description: 'Wyświetlana w „O aplikacji” oraz przy składaniu zgłoszenia.',
    settingKey: LEGAL_SETTING_KEYS.privacy,
  },
  {
    id: 'deklaracja',
    label: 'Deklaracja dostępności',
    description: 'Wyświetlana w „O aplikacji”.',
    settingKey: LEGAL_SETTING_KEYS.deklaracja,
  },
  {
    id: 'informacja',
    label: 'Informacja o przetwarzaniu danych osobowych',
    description: 'Wyświetlana w „O aplikacji” oraz przy składaniu zgłoszenia.',
    settingKey: LEGAL_SETTING_KEYS.informacja,
  },
];

export const ALL_LEGAL_SETTING_KEYS = LEGAL_DOCUMENTS.map((d) => d.settingKey);
